import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import Api from '@/http/api.js'
import Global from '@/global'
import Lang from '@/lang'
const app = axios.create({
  baseURL: 'https://cydex-local.catontechnology.com:9887/cydex/local/v1',
  timeout: 12000
})
app.interceptors.request.use(
  config => {
    config.headers = {
      'active-key': localStorage.getItem('appToken')
    }
    return config
  }
)
app.interceptors.response.use(
  response => {
    if (/(close-active)/i.test(response.config.url)) {
      return response
    }
    // 兼容 client < 3.1 错误号
    const errorNum = response.data.error < 99 ? response.data.error + 100 : response.data.error
    store.dispatch('alertWarn', false)
    store.dispatch('activeApp', true)
    switch (errorNum) {
      case 100:
        store.dispatch('loginApp', true)
        break
      case 101:
      case 109:
        store.dispatch('loginApp', false)
        login()
        break
      case 112:
        Message({
          message: Lang.ui.app.l218,
          type: 'warning',
          duration: 1800
        })
        break
      case 115:
        store.dispatch('showKick', 'kicked')
        store.dispatch('loginApp', false)
        store.dispatch('clearKeep', true)
        break
      case 119:
        if (Global.config.browser === 'qt') {
          store.dispatch('loginApp', false)
          login()
        } else {
          store.dispatch('showKick', 'logout')
          store.dispatch('loginApp', false)
        }
        break
      case 104:
        Message({
          message: Lang.ui.app.l207,
          type: 'warning',
          duration: 1800
        })
        break
      case 152:
      case 153:
      case 154:
      case 155:
      case 156:
      case 157:
      case 158:
        Message({
          message: Lang.ui.app.error['l' + errorNum],
          type: 'warning',
          duration: 1800
        })
        break
      case 299:
        Message({
          message: Lang.systemError['l' + errorNum],
          type: 'warning',
          duration: 1800
        })
        break
      case 1101:
        localStorage.removeItem('token')
        localStorage.removeItem('completeNum')
        localStorage.removeItem('transferInfo')
        window.location.reload()
        break
      case 1113:
        Api.getAppVersion(response => {
          if (Global.config.system === 'mac') {
            var info = {
              newVersion: response.mac.version,
              appVersion: '-',
              downloadUrl: response.mac.downloadUrl
            }
          } else {
            info = {
              newVersion: response.win32.version,
              appVersion: '-',
              downloadUrl: response.win32.downloadUrl
            }
          }
          store.dispatch('setInfo', info)
          store.dispatch('checkVer', true)
        })
        break
      default:
        if (errorNum > 1000) {
          var errorIndex = 'l' + (response.data.error - 1000)
          Message({
            message: Lang.systemError[errorIndex],
            type: 'warning',
            duration: 2000
          })
          if (errorNum === 1300) {
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        }
    }
    return response
  },
  error => {
    if (/(close-active)/i.test(error.config.url)) {
      return Promise.reject(error)
    }
    if (error.response) {
      if (error.response.status === 404) {
        return
      }
    }
    if (localStorage.getItem('token') && localStorage.getItem('token') !== '') {
      store.dispatch('activeAlive', true)
    }
    store.dispatch('activeApp', false)
    store.dispatch('loginApp', false)
    var info = {
      newVersion: '',
      appVersion: '',
      downloadUrl: ''
    }
    store.dispatch('setInfo', info)
    return Promise.reject(error)
  }
)

// var protocol = 'http'
// var domain = '192.168.10.211'
// var port = 80

var protocol = (window.location.protocol).split(':')[0]
var domain = window.location.hostname
if (window.location.port === '') {
  if (window.location.protocol === 'http:') {
    var port = 80
  } else {
    port = 443
  }
} else {
  port = parseInt(window.location.port)
}

const start = () => {
  if (localStorage.getItem('language') === 'zh-cn') {
    var language = 'zh_CN'
  } else {
    language = 'en_US'
  }
  const url = Lang.ui.form.index + language
  const browser = Global.config.browser
  // window.location.href = url
  switch (browser) {
    case 'chrome':
      window.location.href = url
      const error = setTimeout(() => {
        store.dispatch('showDown', true)
        window.removeEventListener('blur', onBlur)
      }, 2000)
      const onBlur = () => {
        store.dispatch('showDown', false)
        clearTimeout(error)
        window.removeEventListener('blur', onBlur)
      }
      window.addEventListener('blur', onBlur)
      break
    case 'firefox':
      let iframe = document.querySelector('#cydex_iframe')
      if (!iframe) {
        iframe = document.createElement('iframe')
        iframe.src = 'about:blank'
        iframe.id = 'cydex_iframe'
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
      }
      try {
        iframe.contentWindow.location.href = url
      } catch (ex) {
        store.dispatch('showDown', true)
      }
      break
  }
}
const login = (force, callback) => {
  var token = localStorage.getItem('token')
  if (!token) {
    return
  }
  if (Global.config.browser !== 'qt') {
    Message({
      message: Lang.ui.app.l146,
      type: 'warning',
      duration: 1800
    })
  }
  if (!force) {
    force = 0
  }
  let browser = Global.config.browser === 'qt' ? 10 : 11
  app.post('/active', {
    'domain': domain,
    'protocol': protocol,
    'port': port,
    'token': token,
    'isForce': force,
    'browserType': browser
  })
    .then(response => {
      if (response.data.error === 0) {
        store.dispatch('loginApp', true)
        let l = localStorage.getItem('language') === 'zh-cn' ? 1 : 0
        setOption(l)
        if (Global.config.browser !== 'qt') {
          Message({
            message: Lang.ui.app.l147,
            type: 'success',
            duration: 2500
          })
        }
        // Notification({
        //   title: Lang.ui.app.l147,
        //   message: Lang.ui.app.l148,
        //   type: 'success',
        //   offset: 80,
        //   duration: 2000
        // })
        var version = response.data.appVersion
        localStorage.setItem('appToken', response.data.activeKey)
        Api.getAppVersion(response => {
          if (Global.config.system === 'mac') {
            var info = {
              newVersion: response.mac.version,
              appVersion: version,
              downloadUrl: response.mac.downloadUrl
            }
          } else {
            info = {
              newVersion: response.win32.version,
              appVersion: version,
              downloadUrl: response.win32.downloadUrl
            }
          }
          store.dispatch('setInfo', info)
        })
        var back = 0
        callback(back)
      } else {
        store.dispatch('loginApp', false)
        const errorNum = response.data.error < 99 ? response.data.error + 100 : response.data.error
        switch (errorNum) {
          case 110:
            if (Global.config.browser !== 'qt') {
              Message({
                message: Lang.ui.app.l146,
                type: 'warning',
                duration: 1800
              })
            }
            break
          case 113:
            Message({
              message: Lang.ui.app.l174 + ': ' + Lang.ui.app.l150,
              type: 'warning',
              duration: 3000
            })
            break
          case 118:
            if (response.data.taskNumber > 0) {
              store.dispatch('showKick', 3)
            } else {
              store.dispatch('showKick', 2)
            }
            store.dispatch('clearKeep', true)
            break
          case 1160:
            store.dispatch('showKick', 1)
            store.dispatch('clearKeep', true)
            break
        }
        back = 1
        callback(back)
      }
    })
    .catch(error => {
      if (error.response) {
        var back = 3
      } else {
        back = 2
      }
      callback(back)
    })
}

// const keep = () => {
//   app.get('/keepalive')
//   .then(response => {
//     if (response.data.error === 0) {
//       store.dispatch('activeApp', true)
//       localStorage.setItem('appServerActive', true)
//     } else {
//       store.dispatch('activeApp', false)
//       localStorage.setItem('appServerActive', false)
//     }
//   })
//   .catch(error => {
//     if (error) {
//       localStorage.setItem('appServerActive', false)
//     }
//   })
// }
const queryTask = (callback) => {
  app.post('/keepalive')
    .then(response => {
      // 兼容Client<9.0错误码 0
      if (response.data.error === 0 || response.data.error === 100) {
        store.dispatch('activeApp', true)
      } else {
        store.dispatch('activeApp', false)
      }
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = ''
        callback(back)
      }
    })
}
const drag = (e, callback) => {
  app.put('/drag-files', e)
    .then(response => {
      var back = ''
      if (response.data.error === 0 || response.data.error === 100) {
        back = response.data
      } else {
        back = 'error'
      }
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appFolder = (callback) => {
  app({
    url: '/choose-folder',
    method: 'get',
    timeout: null
  })
    .then(response => {
      var back = ''
      if (response.data.error === 0 || response.data.error === 100) {
        back = response.data
      } else {
        back = 'error'
      }
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appFiles = (callback) => {
  app({
    url: '/choose-files',
    method: 'get',
    timeout: null
  })
    .then(response => {
      var back = ''
      if (response.data.error === 0 || response.data.error === 100) {
        back = response.data
      } else {
        back = 'error'
      }
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const newPackage = (e, callback) => {
  // app.post('/new-package', e)
  app({
    url: '/package',
    method: 'post',
    data: e,
    timeout: 60000 * 6
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const newTask = (e, callback) => {
  // app.post('/new-task', e)
  app({
    url: '/task',
    method: 'post',
    data: e,
    timeout: 25000
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const list = (e, callback) => {
  app.get('/task-list', { params: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appStart = (type, id, callback) => {
  app.post('/start-task', {
    'taskType': type,
    'taskId': id
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appStop = (type, id, callback) => {
  app.post('/stop-task', {
    'taskType': type,
    'taskId': id
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appDelete = (type, id, callback) => {
  app.post('/delete-tasks', {
    'taskType': type,
    'taskIds': [id]
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const appMove = (type, id, operation, callback) => {
  app.post('/move-task', {
    'taskType': type,
    'taskId': id,
    'operation': operation
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const logout = () => {
  app.post('/close-active')
}
const setOption = (e, callback) => {
  app.post('/options', {
    language: parseInt(e)
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = error.response
        callback(back)
      }
    })
}
const openFloder = (response, callback) => {
  app.get('/open-download-location')
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        if (error.response) {
          var back = 3
          callback(back)
        } else {
          back = 2
          callback(back)
        }
      }
    })
}
const openFileLocation = (params, callback) => {
  app.get('/open-file-location', { params })
    .then(response => {
      callback(response.data)
    })
    .catch(error => {
      if (error) {
        if (error.response) {
          var back = 3
          callback(back)
        } else {
          back = 2
          callback(back)
        }
      }
    })
}
const getSettings = (callback) => {
  app.get('/options')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const setSettings = (e, callback) => {
  app({
    url: '/options',
    method: 'post',
    data: e
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const info = (callback) => {
  app.get('/app')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const openLog = () => {
  app.get('/open-log-location')
}
const taskMore = (type, id, callback) => {
  app.get('/task', { params: {
    taskType: type,
    taskId: id
  } })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const tgList = (callback) => {
  app.get('/tg-list')
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getBitList = (e, callback) => {
  app.get('/taskbitrate-list', { params: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const buildDoor = (e, callback) => {
  app.post('/tg', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const setDoor = (e, callback) => {
  app.put('/tg', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const delDoor = (e, callback) => {
  app.post('/delete-tg', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const startDoor = (e, callback) => {
  app.post('/start-tg', {
    tgPath: e
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const stopDoor = (e, callback) => {
  app.post('/stop-tg', {
    tgPath: e
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const moveUpDoor = (e, callback) => {
  app.post('/move-tg', e)
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const getFilesNum = (e, callback) => {
  app.post('/file-number', { folders: e })
    .then(response => {
      var back = response.data
      callback(back)
    })
    .catch(error => {
      if (error) {
        var back = 1
        callback(back)
      }
    })
}
const setTaskIndex = (type, id, index, callback) => {
  app.post('/set-task-index', {
    taskType: type,
    taskId: id,
    index: index
  })
    .then(response => {
      var back = response.data
      callback(back)
    })
}
const pkgTransferTask = (params, callback) => {
  app.get('/pkg-tasks', { params })
    .then(response => {
      callback(response.data)
    })
}
export default
{
  login,
  logout,
  drag,
  appFolder,
  appFiles,
  start,
  queryTask,
  newPackage,
  newTask,
  list,
  appStart,
  appStop,
  appDelete,
  appMove,
  openFloder,
  setOption,
  getSettings,
  setSettings,
  info,
  openLog,
  taskMore,
  tgList,
  buildDoor,
  setDoor,
  delDoor,
  startDoor,
  stopDoor,
  moveUpDoor,
  getBitList,
  getFilesNum,
  setTaskIndex,
  openFileLocation,
  pkgTransferTask,
}
